module.exports = __webpack_public_path__ + "static/media/va.00e5a3a7.svg";